import * as type from '../../types';

export function getAllBusinessCards() {
    return {
        type: type.FETCH_ALL_BUSINESS_CARDS,
    }
}